// extracted by mini-css-extract-plugin
export default {"savingLoader":"savingLoader__RT_0r"};